function getFocusableElements(t) {
    return Array.from(t.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}
function formatMoney(t, e) {
    "string" == typeof t && (t = t.replace(".", ""));
    var i = /\{\{\s*(\w+)\s*\}\}/,
        s = e || "${{amount}}";
    function r(t, e) {
        return null == t || t != t ? e : t;
    }
    function n(t, e, i, s) {
        if (((e = r(e, 2)), (i = r(i, ",")), (s = r(s, ".")), isNaN(t) || null == t)) return 0;
        var n = (t = (t / 100).toFixed(e)).split(".");
        return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (n[1] ? s + n[1] : "");
    }
    var o = "";
    switch (s.match(i)[1]) {
        case "amount":
            o = n(t, 2);
            break;
        case "amount_no_decimals":
            o = n(t, 0);
            break;
        case "amount_with_space_separator":
            o = n(t, 2, " ", ".");
            break;
        case "amount_no_decimals_with_comma_separator":
            o = n(t, 0, ",", ".");
            break;
        case "amount_no_decimals_with_space_separator":
            o = n(t, 0, " ");
            break;
        case "amount_with_comma_separator":
            o = n(t, 2, ".", ",");
    }
    return -1 !== s.indexOf("with_comma_separator") ? s.replace(i, o).replace(",00", ",00") : s.replace(i, o).replace(".00", ".00");
}
document.querySelectorAll('[id^="Details-"] summary').forEach((t) => {
    t.setAttribute("role", "button"),
        t.setAttribute("aria-expanded", "false"),
        t.nextElementSibling.getAttribute("id") && t.setAttribute("aria-controls", t.nextElementSibling.id),
        t.addEventListener("click", (t) => {
            t.currentTarget.setAttribute("aria-expanded", !t.currentTarget.closest("details").hasAttribute("open"));
            const headerOffset = 109;
            const elementPosition = t.currentTarget.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }),
        t.closest("header-drawer") || t.parentElement.addEventListener("keyup", onKeyUpEscape);
});
const trapFocusHandlers = {};
function trapFocus(t, e = t) {
    var i = getFocusableElements(t),
        s = i[0],
        r = i[i.length - 1];
    removeTrapFocus(),
        (trapFocusHandlers.focusin = (e) => {
            (e.target !== t && e.target !== r && e.target !== s) || document.addEventListener("keydown", trapFocusHandlers.keydown);
        }),
        (trapFocusHandlers.focusout = function () {
            document.removeEventListener("keydown", trapFocusHandlers.keydown);
        }),
        (trapFocusHandlers.keydown = function (e) {
            "TAB" === e.code.toUpperCase() && (e.target !== r || e.shiftKey || (e.preventDefault(), s.focus()), (e.target !== t && e.target !== s) || !e.shiftKey || (e.preventDefault(), r.focus()));
        }),
        document.addEventListener("focusout", trapFocusHandlers.focusout),
        document.addEventListener("focusin", trapFocusHandlers.focusin),
        e && e.focus();
}
try {
    document.querySelector(":focus-visible");
} catch {
    focusVisiblePolyfill();
}
function focusVisiblePolyfill() {
    const t = ["ARROWUP", "ARROWDOWN", "ARROWLEFT", "ARROWRIGHT", "TAB", "ENTER", "SPACE", "ESCAPE", "HOME", "END", "PAGEUP", "PAGEDOWN"];
    let e = null,
        i = null;
    window.addEventListener("keydown", (e) => {
        t.includes(e.code.toUpperCase()) && (i = !1);
    }),
        window.addEventListener("mousedown", (t) => {
            i = !0;
        }),
        window.addEventListener(
            "focus",
            () => {
                e && e.classList.remove("focused"), i || ((e = document.activeElement), e.classList.add("focused"));
            },
            !0
        );
}
function pauseAllMedia() {
    document.querySelectorAll(".js-youtube").forEach((t) => {
        t.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
    }),
        document.querySelectorAll(".js-vimeo").forEach((t) => {
            t.contentWindow.postMessage('{"method":"pause"}', "*");
        }),
        document.querySelectorAll("video").forEach((t) => t.pause()),
        document.querySelectorAll("product-model").forEach((t) => {
            t.modelViewerUI && t.modelViewerUI.pause();
        });
}
function removeTrapFocus(t = null) {
    document.removeEventListener("focusin", trapFocusHandlers.focusin), document.removeEventListener("focusout", trapFocusHandlers.focusout), document.removeEventListener("keydown", trapFocusHandlers.keydown), t && t.focus();
}
function onKeyUpEscape(t) {
    if ("ESCAPE" !== t.code.toUpperCase()) return;
    const e = t.target.closest("details[open]");
    if (!e) return;
    const i = e.querySelector("summary");
    e.removeAttribute("open"), i.setAttribute("aria-expanded", !1), i.focus();
}
class QuantityInput extends HTMLElement {
    constructor() {
        super(),
            (this.input = this.querySelector("input")),
            (this.changeEvent = new Event("change", { bubbles: !0 })),
            this.querySelectorAll("button").forEach((t) => t.addEventListener("click", this.onButtonClick.bind(this))),
            this.querySelector("input").addEventListener("change", this.onInputChange.bind(this));
    }
    onButtonClick(t) {
        t.preventDefault();
        const e = this.input.value;
        let i = e;
        if (("plus" === t.target.name ? this.input.stepUp() : this.input.stepDown(), "plus" === t.target.name ? i++ : i > 1 && i--, null != typeof this.dataset.discount && this.dataset.discount)) {
            let t = 1,
                e = this.dataset.price;
            this.changeProductPrice(i, e, t);
        }
        e !== this.input.value && this.input.dispatchEvent(this.changeEvent);
    }
    onInputChange(t) {
        if (null != typeof this.dataset.discount && this.dataset.discount) {
            let e = t.target.value,
                i = 1,
                s = this.dataset.price;
            this.changeProductPrice(e, s, i);
        }
    }
    changeProductPrice(t, e, i) {
        t >= 250 ? (i = 0.85) : t >= 50 ? (i = 0.9) : t >= 20 ? (i = 0.95) : t >= 5 && (i = 0.97), (document.getElementById("product-price-discount").innerHTML = formatMoney(Math.ceil(e * i), "CHF {{amount}}"));
    }
}
function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
function fetchConfig(t = "json") {
    return { method: "POST", headers: { "Content-Type": "application/json", Accept: `application/${t}` } };
}
customElements.define("quantity-input", QuantityInput),
    void 0 === window.Shopify && (window.Shopify = {}),
    (Shopify.bind = function (t, e) {
        return function () {
            return t.apply(e, arguments);
        };
    }),
    (Shopify.setSelectorByValue = function (t, e) {
        for (var i = 0, s = t.options.length; i < s; i++) {
            var r = t.options[i];
            if (e == r.value || e == r.innerHTML) return (t.selectedIndex = i), i;
        }
    }),
    (Shopify.addListener = function (t, e, i) {
        t.addEventListener ? t.addEventListener(e, i, !1) : t.attachEvent("on" + e, i);
    }),
    (Shopify.postLink = function (t, e) {
        var i = (e = e || {}).method || "post",
            s = e.parameters || {},
            r = document.createElement("form");
        for (var n in (r.setAttribute("method", i), r.setAttribute("action", t), s)) {
            var o = document.createElement("input");
            o.setAttribute("type", "hidden"), o.setAttribute("name", n), o.setAttribute("value", s[n]), r.appendChild(o);
        }
        document.body.appendChild(r), r.submit(), document.body.removeChild(r);
    }),
    (Shopify.CountryProvinceSelector = function (t, e, i) {
        (this.countryEl = document.getElementById(t)),
            (this.provinceEl = document.getElementById(e)),
            (this.provinceContainer = document.getElementById(i.hideElement || e)),
            Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)),
            this.initCountry(),
            this.initProvince();
    }),
    (Shopify.CountryProvinceSelector.prototype = {
        initCountry: function () {
            var t = this.countryEl.getAttribute("data-default");
            Shopify.setSelectorByValue(this.countryEl, t), this.countryHandler();
        },
        initProvince: function () {
            var t = this.provinceEl.getAttribute("data-default");
            t && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, t);
        },
        countryHandler: function (t) {
            var e = (r = this.countryEl.options[this.countryEl.selectedIndex]).getAttribute("data-provinces"),
                i = JSON.parse(e);
            if ((this.clearOptions(this.provinceEl), i && 0 == i.length)) this.provinceContainer.style.display = "none";
            else {
                for (var s = 0; s < i.length; s++) {
                    var r;
                    ((r = document.createElement("option")).value = i[s][0]), (r.innerHTML = i[s][1]), this.provinceEl.appendChild(r);
                }
                this.provinceContainer.style.display = "";
            }
        },
        clearOptions: function (t) {
            for (; t.firstChild; ) t.removeChild(t.firstChild);
        },
        setOptions: function (t, e) {
            var i = 0;
            for (e.length; i < e.length; i++) {
                var s = document.createElement("option");
                (s.value = e[i]), (s.innerHTML = e[i]), t.appendChild(s);
            }
        },
    });
class MenuDrawer extends HTMLElement {
    constructor() {
        super(),
            (this.mainDetailsToggle = this.querySelector("details")),
            "iPhone" === navigator.platform && document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`),
            this.addEventListener("keyup", this.onKeyUp.bind(this)),
            this.addEventListener("focusout", this.onFocusOut.bind(this)),
            this.bindEvents();
    }
    bindEvents() {
        this.querySelectorAll("summary").forEach((t) => t.addEventListener("click", this.onSummaryClick.bind(this))), this.querySelectorAll("button").forEach((t) => t.addEventListener("click", this.onCloseButtonClick.bind(this)));
    }
    onKeyUp(t) {
        if ("ESCAPE" !== t.code.toUpperCase()) return;
        const e = t.target.closest("details[open]");
        e && (e === this.mainDetailsToggle ? this.closeMenuDrawer(t, this.mainDetailsToggle.querySelector("summary")) : this.closeSubmenu(e));
    }
    onSummaryClick(t) {
        document.querySelector(".PageOverlay").classList.add("is-visible"), this.removeStickyHeaderListner();
        const e = t.currentTarget,
            i = e.parentNode,
            s = i.hasAttribute("open"),
            r = window.matchMedia("(prefers-reduced-motion: reduce)");
        function n() {
            trapFocus(e.nextElementSibling, i.querySelector("button")), e.nextElementSibling.removeEventListener("transitionend", n);
        }
        i === this.mainDetailsToggle
            ? (s && t.preventDefault(), s ? this.closeMenuDrawer(t, e) : this.openMenuDrawer(e))
            : setTimeout(() => {
                  i.classList.add("menu-opening"), e.setAttribute("aria-expanded", !0), !r || r.matches ? n() : e.nextElementSibling.addEventListener("transitionend", n);
              }, 100);
    }
    removeStickyHeaderListner() {
        (this.stickyHeader = this.stickyHeader || document.querySelector("sticky-header")),
            this.stickyHeader &&
                (window.removeEventListener("scroll", this.stickyHeader.onScrollHandler, !1),
                setTimeout(() => {
                    window.addEventListener("scroll", this.stickyHeader.onScrollHandler, !1);
                }, 150));
    }
    openMenuDrawer(t) {
        setTimeout(() => {
            this.mainDetailsToggle.classList.add("menu-opening");
        }),
            t.setAttribute("aria-expanded", !0),
            trapFocus(this.mainDetailsToggle, t),
            document.documentElement.classList.add(`overflow-hidden-${this.dataset.breakpoint}`),
            document.querySelector(".PageOverlay").classList.add("is-visible"),
            this.removeStickyHeaderListner();
            if(document.querySelector('#featured-collection-modal')){
                document.querySelector('#featured-collection-modal').style.display = "none";
            }
    }
    closeMenuDrawer(t, e = !1) {
        void 0 !== t &&
            (this.mainDetailsToggle.classList.remove("menu-opening"),
            document.querySelector(".PageOverlay").classList.remove("is-visible"),
            this.mainDetailsToggle.querySelectorAll("details").forEach((t) => {
                t.removeAttribute("open"), t.classList.remove("menu-opening");
            }),
            document.documentElement.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`),
            removeTrapFocus(e),
            this.closeAnimation(this.mainDetailsToggle));
    }
    onFocusOut(t) {
        setTimeout(() => {
            this.mainDetailsToggle.hasAttribute("open") && !this.mainDetailsToggle.contains(document.activeElement) && this.closeMenuDrawer();
        });
    }
    onCloseButtonClick(t) {
        const e = t.currentTarget.closest("details");
        this.closeSubmenu(e);
    }
    closeSubmenu(t) {
        t.classList.remove("menu-opening"), t.querySelector("summary").setAttribute("aria-expanded", !1), removeTrapFocus(), this.closeAnimation(t);
    }
    closeAnimation(t) {
        let e;
        const i = (s) => {
            void 0 === e && (e = s);
            s - e < 400 ? window.requestAnimationFrame(i) : (t.removeAttribute("open"), t.closest("details[open]") && trapFocus(t.closest("details[open]"), t.querySelector("summary")));
        };
        window.requestAnimationFrame(i);
    }
}
customElements.define("menu-drawer", MenuDrawer);
class HeaderDrawer extends MenuDrawer {
    constructor() {
        super();
    }
    openMenuDrawer(t) {
        (this.header = this.header || document.getElementById("shopify-section-header")),
            (this.borderOffset = this.borderOffset || this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom") ? 1 : 0),
            document.documentElement.style.setProperty("--header-bottom-position", `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`),
            setTimeout(() => {
                this.mainDetailsToggle.classList.add("menu-opening");
            }),
            t.setAttribute("aria-expanded", !0),
            trapFocus(this.mainDetailsToggle, t),
            document.documentElement.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }
}
customElements.define("header-drawer", HeaderDrawer);
class ModalDialog extends HTMLElement {
    constructor() {
        super(),
            this.querySelector('[id^="ModalClose-"]').addEventListener("click", this.hide.bind(this)),
            this.addEventListener("keyup", (t) => {
                "ESCAPE" === t.code.toUpperCase() && this.hide();
            }),
            this.classList.contains("media-modal")
                ? this.addEventListener("pointerup", (t) => {
                      //"mouse" !== t.pointerType || t.target.closest("deferred-media, product-model") || this.hide();
                  })
                : this.addEventListener("click", (t) => {
                      "MODAL-DIALOG" === t.target.nodeName && this.hide();
                  });
    }
    show(t) {
        this.openedBy = t;
        const e = this.querySelector(".template-popup");
        document.body.classList.add("overflow-hidden"), this.setAttribute("open", ""), e && e.loadContent(), trapFocus(this, this.querySelector('[role="dialog"]'));
    }
    hide() {
        document.body.classList.remove("overflow-hidden"), this.removeAttribute("open"), removeTrapFocus(this.openedBy), window.pauseAllMedia();
    }
}
customElements.define("modal-dialog", ModalDialog);
class ModalOpener extends HTMLElement {
    constructor() {
        super();
        const t = this.querySelector("button");
        t &&
            t.addEventListener("click", () => {
                const e = document.querySelector(this.getAttribute("data-modal"));
                e && e.show(t);

                const btn = this.querySelector('.product__media-toggle');
                const btn_data_media_id = btn.getAttribute("data-media-id");
                const active_media = document.querySelector(`product-modal [data-media-id="${btn_data_media_id}"]`);
                const slider_active_media = active_media.closest('.swiper-slide');
                const index_slider_active_media = slider_active_media.getAttribute('data-swiper-media-id');
                const index_slider_active_media_int = parseInt(index_slider_active_media);

                console.log(active_media, slider_active_media, index_slider_active_media, index_slider_active_media_int);

                e.goToIndex(index_slider_active_media_int)
            });
    }
}
customElements.define("modal-opener", ModalOpener);
class DeferredMedia extends HTMLElement {
    constructor() {
        super();
        const t = this.querySelector('[id^="Deferred-Poster-"]');
        t && t.addEventListener("click", this.loadContent.bind(this));
    }
    loadContent(t = !0) {
        if ((window.pauseAllMedia(), !this.getAttribute("loaded"))) {
            const e = document.createElement("div");
            e.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(!0)), this.setAttribute("loaded", !0);
            const i = this.appendChild(e.querySelector("video, model-viewer, iframe"));
            t && i.focus();
        }
    }
}
customElements.define("deferred-media", DeferredMedia);
class SliderComponent extends HTMLElement {
    constructor() {
        if (
            (super(),
            (this.slider = this.querySelector('[id^="Slider-"]')),
            (this.sliderItems = this.slider.querySelectorAll(':scope > [id^="Slide-"]')),
            (this.enableSliderLooping = !1),
            (this.sliderButtons = this.querySelector(":scope > .slider-buttons")),
            (this.sliderFirstItemNode = this.slider.querySelector(":scope > .slider__slide")),
            (this.sliderControlLinksArray = Array.from(this.querySelectorAll(".slider-counter__link--per-dot"))),
            this.sliderControlLinksArray.forEach((t) => t.addEventListener("click", this.linkToSlide.bind(this))),
            this.sliderButtons
                ? ((this.currentPageElement = this.sliderButtons.querySelector(".slider-counter--current")),
                  (this.pageTotalElement = this.sliderButtons.querySelector(".slider-counter--total")),
                  (this.prevButton = this.sliderButtons.querySelector('button[name="previous"]') || this.querySelector(":scope > ")),
                  (this.nextButton = this.sliderButtons.querySelector('button[name="next"]') || this.querySelector(":scope > ")))
                : ((this.prevButton = this.querySelector('button[name="previous"]')), (this.nextButton = this.querySelector('button[name="next"]'))),
            !this.slider || !this.sliderButtons & !this.prevButton)
        )
            return;
        this.initPages();
        new ResizeObserver((t) => this.initPages()).observe(this.slider),
            this.slider.addEventListener("scroll", this.update.bind(this)),
            this.prevButton.addEventListener("click", this.onButtonClick.bind(this)),
            this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
    }
    linkToSlide(t) {
        t.preventDefault();
        const e = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(t.currentTarget) + 1 - this.currentPage);
        this.slider.scrollTo({ left: e });
    }
    initPages() {
        (this.sliderItemsToShow = Array.from(this.sliderItems).filter((t) => t.clientWidth > 0)),
            (this.sliderLastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1]),
            0 !== this.sliderItemsToShow.length &&
                ((this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth)), (this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1), this.update());
    }
    resetPages() {
        (this.sliderItems = this.slider.querySelectorAll(':scope [id^="Slide-"]')), this.initPages();
    }
    update() {
        const t = this.currentPage;
        if (
            ((this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1),
            this.currentPageElement && this.pageTotalElement && ((this.currentPageElement.textContent = this.currentPage), (this.pageTotalElement.textContent = this.totalPages)),
            this.currentPage != t && this.dispatchEvent(new CustomEvent("slideChanged", { detail: { currentPage: this.currentPage, currentElement: this.sliderItemsToShow[this.currentPage - 1] } })),
            !this.enableSliderLooping &&
                (this.sliderButtons))
        ) {
            if (((this.sliderControlButtons = this.sliderButtons.querySelectorAll(":scope .slider-counter__link--per-dot")), !this.sliderControlButtons.length)) return;
            this.sliderControlButtons.forEach((t) => {
                t.classList.remove("slider-counter__link--active"), t.removeAttribute("aria-current");
            });
            try {
                this.sliderControlButtons[this.currentPage - 1].classList.add("slider-counter__link--active"), this.sliderControlButtons[this.currentPage - 1].setAttribute("aria-current", !0);
            } catch (t) {
                console.log(t);
            }
        }
    }
    isSlideVisible(t, e = 0) {
        const i = this.slider.clientWidth + this.slider.scrollLeft - e;
        return t.offsetLeft + t.clientWidth <= i && t.offsetLeft >= this.slider.scrollLeft;
    }
    onButtonClick(t, isOnHover) {
        if(!isOnHover){
            t.preventDefault();
        }

        const e = t.currentTarget.dataset.step || 1;
        if(this.slider.hasAttribute('infinite-scroll')){
            if(t.currentTarget.name === "next"){
                if (this.slider.scrollLeft + e * this.sliderLastItem.clientWidth >= this.slider.scrollWidth) {
                    this.slider.scrollTo({ left: 0 });
                    return;
                }
            }
            if(t.currentTarget.name === "previous"){
                if (this.slider.scrollLeft === 0) {
                    this.slideScrollPosition = this.slider.scrollWidth - this.sliderLastItem.clientWidth;
                    this.slider.scrollTo({ left: this.slideScrollPosition });
                    return;
                }
            }
        }
        (this.slideScrollPosition = "next" === t.currentTarget.name ? this.slider.scrollLeft + e * this.sliderLastItem.clientWidth : this.slider.scrollLeft - e * this.sliderLastItem.clientWidth),
            this.slider.scrollTo({ left: this.slideScrollPosition });
    }
}
customElements.define("slider-component", SliderComponent);
class SlideshowComponent extends SliderComponent {
    constructor() {
        super(),
            (this.sliderControlWrapper = this.querySelector(":scope > .slider-buttons")),
            (this.enableSliderLooping = !0),
            this.sliderControlWrapper &&
                ((this.sliderFirstItemNode = this.slider.querySelector(":scope > .slideshow__slide")),
                this.sliderItemsToShow.length > 0 && (this.currentPage = 1),
                (this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll(".slider-counter__link"))),
                this.sliderControlLinksArray.forEach((t) => t.addEventListener("click", this.linkToSlide.bind(this))),
                this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this)),
                this.setSlideVisibility(),
                "true" === this.slider.getAttribute("data-autoplay") && this.setAutoPlay());
    }
    setAutoPlay() {
        this.sliderAutoplayButton = this.sliderControlWrapper.querySelector(":scope .slideshow__autoplay");
        this.autoplaySpeed = 1e3 * this.slider.dataset.speed;
        this.sliderAutoplayButton.addEventListener("click", this.autoPlayToggle.bind(this));

        if (this.hasAttribute("stop-on-hover")) {
            this.addEventListener("mouseover", this.focusInHandling.bind(this));
            this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
            this.addEventListener("focusin", this.focusInHandling.bind(this));
            this.addEventListener("focusout", this.focusOutHandling.bind(this));
        }

        this.play();
        this.autoplayButtonIsSetToPlay = !0;
    }
    onButtonClick(t) {
        super.onButtonClick(t);
        const e = 1 === this.currentPage,
            i = this.currentPage === this.sliderItemsToShow.length;
        (e || i) &&
            (e && "previous" === t.currentTarget.name
                ? (this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length)
                : i && "next" === t.currentTarget.name && (this.slideScrollPosition = 0),
            this.slider.scrollTo({ left: this.slideScrollPosition }));
    }
    update() {
        if (
            (super.update(),
            (this.sliderButtons = this.querySelector(":scope > .slider-buttons")),
            (this.sliderControlButtons = this.sliderButtons.querySelectorAll(":scope .slider-counter__link")),
            this.prevButton.removeAttribute("disabled"),
            this.sliderControlButtons.length)
        ) {
            this.sliderControlButtons.forEach((t) => {
                t.classList.remove("slider-counter__link--active"), t.removeAttribute("aria-current");
            });
            try {
                this.sliderControlButtons[this.currentPage - 1].classList.add("slider-counter__link--active"), this.sliderControlButtons[this.currentPage - 1].setAttribute("aria-current", !0);
            } catch (t) {
                console.log(t);
            }
        }
    }
    autoPlayToggle() {
        this.togglePlayButtonState(this.autoplayButtonIsSetToPlay), this.autoplayButtonIsSetToPlay ? this.pause() : this.play(), (this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay);
    }
    focusOutHandling(t) {
        const e = t.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(t.target);
        this.autoplayButtonIsSetToPlay && !e && this.play();
    }
    focusInHandling(t) {
        (t.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(t.target)) && this.autoplayButtonIsSetToPlay ? this.play() : this.autoplayButtonIsSetToPlay && this.pause();
    }
    play() {
        this.slider.setAttribute("aria-live", "off"), clearInterval(this.autoplay), (this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed));
    }
    pause() {
        this.slider.setAttribute("aria-live", "polite"), clearInterval(this.autoplay);
    }
    togglePlayButtonState(t) {
        t
            ? (this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused"), this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.playSlideshow))
            : (this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused"), this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.pauseSlideshow));
    }
    autoRotateSlides() {
        const t = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector(":scope > .slideshow__slide").clientWidth;
        this.slider.scrollTo({ left: t });
    }
    setSlideVisibility() {
        this.sliderItemsToShow.forEach((t, e) => {
            const i = t.querySelector("a");
            e === this.currentPage - 1
                ? (i && i.removeAttribute("tabindex"), t.setAttribute("aria-hidden", "false"), t.removeAttribute("tabindex"))
                : (i && i.setAttribute("tabindex", "-1"), t.setAttribute("aria-hidden", "true"), t.setAttribute("tabindex", "-1"));
        });
    }
    linkToSlide(t) {
        t.preventDefault();
        const e = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(t.currentTarget) + 1 - this.currentPage);
        this.slider.scrollTo({ left: e });
    }
}
customElements.define("slideshow-component", SlideshowComponent);
class VariantSelects extends HTMLElement {
    constructor() {
        super(), this.addEventListener("change", this.onVariantChange);
    }
    onVariantChange() {
        this.updateOptions(),
            this.updateMasterId(),
            this.toggleAddButton(!0, "", !1),
            this.updatePickupAvailability(),
            this.removeErrorMessage(),
            this.currentVariant ? (this.updateMedia(), this.updateURL(), this.updateVariantInput(), this.updateInputQuantity(), this.renderProductInfo(), this.updateShareUrl()) : (this.toggleAddButton(!0, "", !0), this.setUnavailable());
    }
    updateOptions() {
        this.options = Array.from(this.querySelectorAll("select"), (t) => t.value);
    }
    updateMasterId() {
        this.currentVariant = this.getVariantData().find((t) => !t.options.map((t, e) => this.options[e] === t).includes(!1));
    }
    updateMedia() {
        if (!this.currentVariant) return;
        if (JSON.parse(document.getElementById("ProductMedia")?.getAttribute("data-variant-images") || !1)) {
            if(window.innerWidth > 880){
                const t = document.getElementById(`desktop-MediaGallery-${this.dataset.section}-${this.currentVariant.id}`),
                e = document.querySelectorAll("media-gallery");
                for (const t of e) t.classList.add("hidden");
                return void t.classList.remove("hidden");
            } else {
                const t = document.getElementById(`mobile-MediaGallery-${this.dataset.section}-${this.currentVariant.id}`),
                e = document.querySelectorAll("media-gallery");
                for (const t of e) t.classList.add("hidden");
                return void t.classList.remove("hidden");
            }
        }
        if (!this.currentVariant.featured_media) return;
        if(window.innerWidth > 880){
            document.getElementById(`desktop-MediaGallery-${this.dataset.section}`).setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, !0);
        } else {
            document.getElementById(`mobile-MediaGallery-${this.dataset.section}`).setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, !0);
        }
        const t = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`),
            e = t.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
        t.prepend(e);
    }
    updateURL() {
        this.currentVariant && "false" !== this.dataset.updateUrl && window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
    updateShareUrl() {
        const t = document.getElementById(`Share-${this.dataset.section}`);
        t && t.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
    updateVariantInput() {
        document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`).forEach((t) => {
            const e = t.querySelector('input[name="id"]');
            (e.value = this.currentVariant.id), e.dispatchEvent(new Event("change", { bubbles: !0 }));
        });
    }
    updateInputQuantity() {
        const t = document.getElementById(`Quantity-${this.dataset.section}`);
        (t.value = 1), t.dispatchEvent(new Event("change", { bubbles: !0 }));
    }
    updatePickupAvailability() {
        const t = document.querySelector("pickup-availability");
        t && (this.currentVariant && this.currentVariant.available ? t.fetchAvailability(this.currentVariant.id) : (t.removeAttribute("available"), (t.innerHTML = "")));
    }
    removeErrorMessage() {
        const t = this.closest("section");
        if (!t) return;
        const e = t.querySelector("product-form");
        e && e.handleErrorMessage();
    }
    renderProductInfo() {
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
            .then((t) => t.text())
            .then((t) => {
                const e = `price-${this.dataset.section}`,
                    i = new DOMParser().parseFromString(t, "text/html"),
                    s = document.getElementById(e),
                    r = i.getElementById(e);
                r && s && (s.innerHTML = r.innerHTML);
                const n = document.getElementById(`price-${this.dataset.section}`),
                    o = document.getElementById("variant__title"),
                    a = i.querySelector("#product__sku");
                (document.querySelector("#product__sku").innerHTML = a.innerHTML),
                    n && n.classList.remove("visibility-hidden"),
                    o && (o.innerHTML = this.currentVariant.title),
                    this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
                if(document.querySelector('.short_description_container')){
                    const newProductDescription = i.querySelector('.short_description_container');
                    document.querySelector('.short_description_container').innerHTML = newProductDescription.innerHTML;
                }
                if(document.querySelector('.measurements-image-container')){
                    const measurements_image = i.querySelector('.measurements-image-container');
                    document.querySelector('.measurements-image-container').innerHTML = measurements_image.innerHTML;
                }
                if((document.querySelector('.product_icons_container')) && (i.querySelector('.product_icons_container'))){
                    const product_icons = i.querySelector('.product_icons_container');
                    document.querySelector('.product_icons_container').innerHTML = product_icons.innerHTML;
                }
                if(i.querySelector('.collapsible_tab_container')){
                    const collapsible_tabs_container = i.querySelectorAll('.collapsible_tab_container');
                    document.querySelectorAll('.collapsible_tab_container').forEach((collapsible_tab_container, index) => {
                        collapsible_tab_container.innerHTML = collapsible_tabs_container[index].innerHTML;
                    });
                }

                updateDeliveryDate();

            });
    }
    toggleAddButton(t = !0, e, i = !0) {
        const s = document.getElementById(`product-form-${this.dataset.section}`);
        if (!s) return;
        const r = s.querySelector('[name="add"]'),
            n = s.querySelector('[name="add"] > span');
        r && (t ? (r.setAttribute("disabled", "disabled"), e && (n.textContent = e)) : (r.removeAttribute("disabled"), (n.textContent = window.variantStrings.addToCart)));
    }
    setUnavailable() {
        const t = document.getElementById(`product-form-${this.dataset.section}`),
            e = t.querySelector('[name="add"]'),
            i = t.querySelector('[name="add"] > span'),
            s = document.getElementById(`price-${this.dataset.section}`);
        e && ((i.textContent = window.variantStrings.unavailable), s && s.classList.add("visibility-hidden"));
    }
    getVariantData() {
        return (this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent)), this.variantData;
    }
}
customElements.define("variant-selects", VariantSelects);
class VariantRadios extends VariantSelects {
    constructor() {
        super();
    }
    updateOptions() {
        const t = Array.from(this.querySelectorAll("fieldset"));
        this.options = t.map((t) => Array.from(t.querySelectorAll("input")).find((t) => t.checked).value);
    }
}
customElements.define("variant-radios", VariantRadios);
class VariantColor extends VariantSelects {
    constructor() {
        super(), this.updateCheck();
    }
    onVariantChange() {
        this.updateOptions(), this.updateMasterId(), this.updateFormVariantId(), this.updateMedia();
    }
    updateCheck() {
        const t = Array.from(this.querySelectorAll("fieldset"));
        [].filter
            .call(t, function (t) {
                return "flex" == window.getComputedStyle(t).display;
            })
            .map((t) => {
                var e = t.querySelectorAll("input");
                e &&
                    e.forEach((t) => {
                        t.classList.contains("color-swatcher__active") && (t.checked = !0);
                    });
            });
    }
    updateOptions() {
        const t = Array.from(this.querySelectorAll("fieldset"));
        var e = [].filter.call(t, function (t) {
            return "none" !== window.getComputedStyle(t).display;
        });
        e.map((t) => {
            var e = t.querySelectorAll("input");
            e &&
                e.forEach((t) => {
                    t.classList.contains("color-swatcher__active") && t.classList.remove("color-swatcher__active");
                }),
                e &&
                    e.forEach((t) => {
                        t.checked && (t.classList.contains("color-swatcher__active") || t.classList.add("color-swatcher__active"));
                    });
        }),
            (this.options = e.map((t) => Array.from(t.querySelectorAll("input")).find((t) => t.checked).value));
    }
    updateFormVariantId() {
        if (!this.currentVariant.id) return;
        const idInput = this.closest(".card-wrapper").querySelector('input[name="id"]');
        if (idInput) idInput.value = this.currentVariant.id;
    }
    updateMedia() {
      const currentVariant = this.currentVariant;
      const section = this.dataset.section;
      const index = this.dataset.index;
      const productId = this.dataset.productId;
      if (!currentVariant) return;
      const cardSelector = `.card--product-${productId}-${section}-${index}`;
      const cardImageContainer = document.querySelector(`${cardSelector} .media`);
      const targetImage = cardImageContainer.querySelector('.target-image');
      const secondaryImage = cardImageContainer.querySelector('.secondary-image');
      const cardInner = document.querySelector(`${cardSelector} .card__inner`);
      const cardInformation = document.querySelector(`.card-wrapper-${productId}-${section}-${index} .card-information__text a`);
      const selectedOption = this.querySelector(`input[variant-id="${currentVariant.id}"]`);
      const cardData = {selector: cardSelector};

      const image1 = selectedOption.dataset.image1;
      const secondImageUrl = selectedOption.dataset.image2;

      const updateLinkHref = (link) => {
        if (link) {
          const variantParam = `variant=${currentVariant.id}`;
          const href = link.getAttribute('href');
          const newHref = href.includes('?') ? `${href}&${variantParam}` : `${href}?${variantParam}`;
          link.setAttribute('href', newHref);
        }
      };

      updateLinkHref(cardInner);
      updateLinkHref(cardInformation);

      const { featured_media } = currentVariant;

      const firstImageUrl = image1 || featured_media;

      if (firstImageUrl) {
        if (!targetImage) {
          const img = document.createElement("img");
          img.className = "motion-reduce lazyload image--fade-in target-image";
          img.setAttribute("data-src", firstImageUrl);
          img.setAttribute("data-srcset", firstImageUrl);
          img.setAttribute("srcset", firstImageUrl);
          cardImageContainer.appendChild(img);
        } else {
          targetImage.setAttribute("data-src", firstImageUrl);
          targetImage.setAttribute("data-srcset", firstImageUrl);
          targetImage.setAttribute("srcset", firstImageUrl);
        }
      } else {
        if (targetImage) {
          cardImageContainer.removeChild(targetImage);
        }
      }

      if (secondImageUrl) {
        if (!secondaryImage) {
          const img = document.createElement("img");
          img.className = "motion-reduce lazyloaded image--fade-in secondary-image";
          img.setAttribute("data-src", secondImageUrl);
          img.setAttribute("data-srcset", secondImageUrl);
          img.setAttribute("srcset", secondImageUrl);
          cardImageContainer.appendChild(img);
        } else {
          secondaryImage.setAttribute("data-src", secondImageUrl);
          secondaryImage.setAttribute("data-srcset", secondImageUrl);
          secondaryImage.setAttribute("srcset", secondImageUrl);
        }
      } else {
        if (secondaryImage) {
          cardImageContainer.removeChild(secondaryImage);
        }
      }
    }
    updateVoucherCode() {
        const currentVariant = this.currentVariant;
        const section = this.dataset.section;
        const index = this.dataset.index;
        const productId = this.dataset.productId;
        if (!currentVariant) return;
        const cardSelector = `.card--product-information-${productId}-${section}-${index}`;
        const cardPriceVoucher = document.querySelector(`${cardSelector} .price__voucher`);
        const cardSelectorBadge = `.card--product-${productId}-${section}-${index}`;
        const cardDiscountVoucher = document.querySelector(`${cardSelectorBadge} .card__badge-voucher-discount`);
        const selectedOption = this.querySelector(`input[variant-id="${currentVariant.id}"]`);
        const priceWithDiscount = selectedOption.dataset.pricewithdiscount;
        const discountPercentage = selectedOption.dataset.discount_percentage;
        if(priceWithDiscount && cardPriceVoucher){
            cardPriceVoucher.querySelector('span').innerHTML = priceWithDiscount;
            cardDiscountVoucher.innerHTML = '- ' + discountPercentage + ' %';
        }
    }
}
customElements.define("variant-color", VariantColor);
